import {ConfigStructure} from "../config-structure.model";
import {SuggestionsStructure} from "../../search/suggestions/suggestions-structure.model";

export class SuggestionsConfigStructure extends SuggestionsStructure {

  titleStructures: ConfigStructure[] = [];

  thumbnail: string;

  thumbnailWcga: string;

  subTitleTranslation: string;

  limitAlt = 2;

  constructor(attr: { limitAlt?: number, objectType: string, maxSuggest: number, thumbnail: string, thumbnailWcga: string, subTitleTranslation: string, titleStructures: ConfigStructure[] }) {
    super(attr);
    this.thumbnail = attr.thumbnail;
    this.subTitleTranslation = attr.subTitleTranslation;
    this.thumbnailWcga = attr.thumbnailWcga;
    if (attr.titleStructures) {
      attr.titleStructures.forEach(titleStructure => this.titleStructures.push(new ConfigStructure(titleStructure)));
    }
    if (attr.limitAlt) {
      this.limitAlt = attr.limitAlt;
    }

  }
}
